import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.errors.";

const unchosenProfessionalCriterionSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "unchosen_professional_criterion" },
);

const insuranceRequestsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const calendarsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const physicianSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const specialtyRequestsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const thenPrioritiesSchema = z
  .object({
    offerPriority: z.string().nullish(),
    calendars: calendarsSchema.nullish(),
    physicians: physicianSchema.nullish(),
  })
  .superRefine((val, ctx) => {
    if (!val.offerPriority) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "offer_priority",
        path: ["offerPriority"],
      });
    }

    if (!val.calendars && !val.physicians) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "offers",
        path: ["calendars"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "offers",
        path: ["physicians"],
      });
    }
  });

export const unchosenProfessionalPrioritySchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z.string().min(1, translationPath + "name"),
  unchosenProfessionalCriterion: unchosenProfessionalCriterionSchema,
  initialAge: z.string().nullish(),
  finalAge: z.string().nullish(),
  priority: z.string().nullish(),
  insuranceRequests: z.array(insuranceRequestsSchema).nullish(),
  specialtyRequests: z.array(specialtyRequestsSchema).nullish(),
  thenPriorities: z
    .array(thenPrioritiesSchema)
    .nullish()
    .superRefine((val, ctx) => {
      const offerPriorities = val?.map((item, index) => ({
        index,
        value: item.offerPriority!,
      }));
      const duplicates = offerPriorities?.filter(
        (item, index) =>
          offerPriorities?.findIndex(
            (offerPriority) => offerPriority.value === item.value,
          ) !== index,
      );

      if (duplicates && duplicates.length > 0) {
        duplicates.forEach((item) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: translationPath + "offer_priority_duplicated",
            path: [`${item.index}.offerPriority`],
          });
        });
      }
    }),
});

export type TUnchosenProfessionalPriorityForm = z.infer<
  typeof unchosenProfessionalPrioritySchema
>;
